import { ToolbarIcon } from '@instinet-analytics/semantic-ui-components';
import React, { useState } from 'react';
import { ShareWidgetConfigModal } from 'widgets/configSharing/shareWidgetConfigModal/ShareWidgetConfigModal';
import { useWidgetContext } from 'widgets/WidgetContext';

export function ShareWidgetConfigToolbarButton() {
    const { widgetType } = useWidgetContext();

    const [isModalOpen, setIsModalOpen] = useState(false);

    const onButtonClick = () => {
        setIsModalOpen(true);
    };

    const closeModal = () => {
        setIsModalOpen(false);
    };

    return (
        <>
            <ToolbarIcon
                name="block layout"
                className="ShareWidgetConfigToolbarButton"
                tooltip="Manage Widget Layouts"
                onClick={onButtonClick}
            />
            <ShareWidgetConfigModal
                isOpen={isModalOpen}
                onActionCompleted={closeModal}
                widgetType={widgetType}
            />
        </>
    );
}
